// extracted by mini-css-extract-plugin
export default {"divider":"filterCollapsable_divider__GnO-H"};